import type { AssetBalanceDto } from '@shared/api/contracts';
import { isUnallocatedNetwork } from '@shared/constants/network';

export const getAssetBalanceKey = (assetCode: string, network: string): string =>
  `${assetCode}:${network}`;

export const isAssetBalanceRecord = (value: unknown): value is AssetBalanceDto => {
  if (typeof value !== 'object' || value == null) {
    return false;
  }

  const record = value as Partial<AssetBalanceDto>;
  return (
    typeof record.amount === 'string' &&
    typeof record.assetCode === 'string' &&
    typeof record.network === 'string'
  );
};

export const normalizeAssetBalances = (value: unknown): AssetBalanceDto[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(isAssetBalanceRecord);
};

export const formatAssetNetworkLabel = (
  network: string,
  historicalLabel: string,
): string => (isUnallocatedNetwork(network) ? historicalLabel : network);
